// favicon — the brand cube as a tab icon. A rounded brand-colored tile with an
// on-primary cube glyph; reads down to 16px and stays visible on light AND dark
// tab bars (the tile carries its own background). Tinted to the active project,
// platform default elsewhere. Self-hosted data-URI (air-gap per ADR-013) and
// strict-CSP-safe (no inline script — set from app JS).
//
// Per-customer (deployment) favicon override stays deferred (CONVENTIONS
// §Branding) — this is platform brand + per-project tint only.

import { PLATFORM_COLOR_PRIMARY, PLATFORM_COLOR_ON_PRIMARY } from '../branding.js';

/** Build a data-URI for the cube favicon in the given brand colours. */
export function cubeFaviconHref(
  brand: string = PLATFORM_COLOR_PRIMARY,
  onBrand: string = PLATFORM_COLOR_ON_PRIMARY,
): string {
  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">` +
    `<rect width="32" height="32" rx="7" fill="${brand}"/>` +
    `<g fill="none" stroke="${onBrand}" stroke-width="2.2" stroke-linejoin="round" stroke-linecap="round">` +
    `<polygon points="16,5 26,10.5 26,21.5 16,27 6,21.5 6,10.5"/>` +
    `<path d="M16 16 26 10.5M16 16 16 27M16 16 6 10.5"/></g></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

/** Set (or create) the document's <link rel="icon"> to the given href. */
export function setFavicon(href: string): void {
  let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.type = 'image/svg+xml';
  link.href = href;
}
